import React, { useRef, useEffect, useState, useLayoutEffect, useContext } from "react"
import {gsap} from "gsap"
import { FlickingError, ERROR_CODE } from "@egjs/react-flicking";
import SwipeListener from 'swipe-listener';

import elementInside from './dataExperience'
import Slider from "../slider/slider"
import NewImg from "./element/newImg"
import Context from "../store/context"
import SplashScreen from "../UI/splashScreen/splashScreen";

const Experience = () =>{

  const [currentPhoto,setCurrentPhoto] = useState();
  const [newPhoto,setNewPhoto] = useState();

  const colorCtx = useContext(Context)

  const SwipeRef = useRef()
  const flickRef = useRef()

  const lang = document.documentElement.lang === "it"

  const isBrowser = typeof window !== "undefined"

  useLayoutEffect(() => {
    window.addEventListener('resize', () => {
      document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`)
    });
  }, [isBrowser] )
  
  useEffect(() => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  elementInside[colorCtx.color].color);
    let mm = gsap.matchMedia();
    mm.add("(min-width: 769px)", () => {
      setNewPhoto(elementInside[colorCtx.color].photo);
      gsap.fromTo(".experience__view__img__current",{opacity:1},{opacity:0, duration: .8, onComplete: () => setCurrentPhoto(elementInside[colorCtx.color].photo)});
    });
    mm.add("(max-width: 768px)", () => {
      setNewPhoto(elementInside[colorCtx.color].photoM);
      gsap.fromTo(".experience__view__img__current",{opacity:1},{opacity:0, duration: .8, onComplete: () => setCurrentPhoto(elementInside[colorCtx.color].photoM)});
    });
    document.documentElement.style.setProperty("--mainColor", elementInside[colorCtx.color].color);

    
    async function sync(){
      try {
            await flickRef.current.moveTo(colorCtx.color);
      }
      catch (err) {
        if (err instanceof FlickingError) {
          if (err.code === ERROR_CODE.ANIMATION_ALREADY_PLAYING) {
          } else if (err.code === ERROR_CODE.ANIMATION_INTERRUPTED) {
          }
        }
      }
    }
    sync()
  },[colorCtx.color])
  
  useEffect(() => {
    const listener = SwipeListener(SwipeRef.current);
    SwipeRef.current.addEventListener('swipe', function (e) {
      let directions = e.detail.directions;
      let x = e.detail.x;
      let y = e.detail.y;
      
      directions.left && nextHandler();
      directions.right && prevHandler();
        gsap.to(".slider__cta", 2, { autoAlpha:0, ease: "back.out(1.7)"});
        gsap.to(".slider__ctaClick", 2, { autoAlpha:0, ease: "back.out(1.7)"});
    })
  })
  
  const prevHandler = () => {
    flickRef.current.prev()

  }
  const nextHandler = () => {
    flickRef.current.next()
  }

  const cursorEnter = (el) => {
      document.getElementById("cursorID").classList.add(el);
  }
  const cursorLeave = (el) => {
      document.getElementById("cursorID").classList.remove(el);
  }

  return(
    <>
      <SplashScreen />
      <div className="experience" >
        <div className="experience__view" >
          <div className="experience__view__clicker">
            <span className="experience__view__clicker--prev" onMouseEnter={() => cursorEnter("prev")} onMouseLeave={() => cursorLeave("prev")} onClick={prevHandler} />
            <a className="experience__view__clicker--view" ref={SwipeRef} onMouseEnter={() => cursorEnter("view")} onMouseLeave={() => cursorLeave("view")} href={`${lang ? elementInside[colorCtx.color].name.it.toLowerCase() : elementInside[colorCtx.color].name.en.toLowerCase() }.html`} />
            <span className="experience__view__clicker--next" onMouseEnter={() => cursorEnter("after")} onMouseLeave={() => cursorLeave("after")} onClick={nextHandler} />
          </div>
          {newPhoto && < NewImg cN="experience__view__img__new" img={newPhoto} />}
          <NewImg cN="experience__view__img__current" img={currentPhoto}/>
        </div>
        <Slider cN="experience__slider" isRef={flickRef} color={colorCtx.color} setColor={(e) => colorCtx.setColor(e)} />
      </div>
    </>
  )
}
  
export default Experience
